/**
 * Presentation-only Chapter partial boundary.
 *
 * This renderer deliberately accepts no body content. The only body which can
 * reach either SSR or SPA is the server-truncated `visibleBody`; every element
 * below the third blurred line is synthetic skeleton UI.
 */
export function renderChapterMeteredTail(
	gate: 'login' | 'paywall',
	requiredPlan?: 'lite' | 'pro' | 'max' | null,
	requiredCapability?: 'githubDeepDive' | null,
): string {
	const clickAction = gate === 'login' ? 'showLoginModal()' : requiredPlan ? `showPaywall('${requiredPlan}')` : 'showPaywall()';
	const legacyLabel = gate === 'login' ? 'Sign in to continue' : 'See plans';
	const capabilityAttribute = gate === 'paywall' && requiredCapability === 'githubDeepDive' ? ' data-required-capability="githubDeepDive"' : '';
	return `<section class="chapter-metered-tail mcg-gate-${gate}" data-mcg-gate data-nosnippet aria-label="${legacyLabel}">
		<div class="chapter-metered-skeleton" aria-hidden="true">
			<span></span><span></span><span></span><span></span><span></span><span></span>
		</div>
		<button class="chapter-metered-lock-zone" type="button" data-proto-click="${clickAction}"${capabilityAttribute}>
			<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"></rect><path d="M8 11V8a4 4 0 0 1 8 0v3"></path></svg>
			<span>Continue with the full chapter</span>
		</button>
	</section>`;
}
